enum BACKEND_ENDPOINTS {
  //TODO: Change to dev URL back to http://34.107.233.243/api
  dev = "http://34.107.233.243/api",
  //TODO: Change to master URL back to http://rurax.com.br/api
  master = "/api",
  //TODO: Change to local URL back to http://localhost:3333/api
  local = "http://localhost:3333/api",
}
let backend_url = "http://localhost:3333/api";

export const MARKETPLACE =
  process.env.REACT_APP_BACKEND !== "master" ||
  process.env.REACT_APP_BACKEND === "master";

switch (process.env.REACT_APP_BACKEND) {
  case "dev":
    backend_url = BACKEND_ENDPOINTS.dev;
    break;
  case "master":
    backend_url = BACKEND_ENDPOINTS.master.startsWith("/")
      ? `${window.location.protocol}//${window.location.host}${BACKEND_ENDPOINTS.master}`
      : BACKEND_ENDPOINTS.master;
    break;
  case "local":
    backend_url = BACKEND_ENDPOINTS.local;
    break;
  default:
    backend_url = BACKEND_ENDPOINTS.dev;
}

const config = {
  backend: backend_url,
  socket:
    process.env.NODE_ENV === "development"
      ? "ws://localhost:3333/api"
      : `${window.location.protocol === "https:" ? "wss:" : "ws:"}//${
          window.location.host
        }/api`,
};

export default config;
